"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.documentView")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company.documentView", {
        url: "/documento/:source/:date",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-document-view" */ "./document-view.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.documentView")
            );
        },
        views: {
            "admin@nucont.accounting": {
                component: "documentViewComponent",
                bindings: { companyData: "CompanyData" }
            }
        },
        params: {
            source: { value: null, dynamic: true },
            date: { value: null, dynamic: true }
        },
        bodyClass: "balance-sheet-module"
    });
}
